export enum PiCategoryEnum {
    GENERAL = 'general',
    PI100K = '100k',
    PI100M = '100m',
    PI20K = '20k',
    PI50K = '50k',
}
